var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table-lite',{attrs:{"striped":"","responsive":"","borderless":"","hover":"","tbody-tr-class":"table-row","items":_vm.ranks,"fields":_vm.fields},on:{"row-clicked":_vm.onRowClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }